import { axiosGet } from "../../Helpers";
import { userTypes } from "./userTypes";

export const loadSpecificUsers = async (
  userType = "Job Seeker",
  setLoading
) => {
  setLoading(true);
  let users = await axiosGet(`user/getUserByRole/${userTypes[userType]}`);
  users.data.data.map((user, index) => (user.id = index + 1));
  setLoading(false);
  return users.data.data;
};
export const loadUsers = async (userType = "Job Seeker", setLoading) => {
  setLoading(true);
  let users = await axiosGet(`user/listUser`);
  users.data.data.map((user, index) => (user.id = index + 1));
  setLoading(false);
  return users.data.data;
};
export const loadRoles = async (setLoading) => {
  setLoading(true);
  let users = await axiosGet(`roles/listRoles`);
  users.data.data.map((user, index) => (user.id = index + 1));
  setLoading(false);
  return users.data.data;
};
